import { render, staticRenderFns } from "./VatEdit.vue?vue&type=template&id=5dc31c6a&"
import script from "./VatEdit.vue?vue&type=script&lang=js&"
export * from "./VatEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports